import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	FormControl, FormGroup, InputGroup, ControlLabel,
} from 'react-bootstrap';

class FieldGroup extends PureComponent {
	render() {
		const {
			id,
			type,
			label,
			placeholder,
			icon,
			validationState,
			name,
			value,
		} = this.props;
		return (
			<FormGroup
				controlId={id}
				validationState={validationState}
			>
				<ControlLabel className="font-regular font-size-15 color-gray-mine-shaft">{ label }</ControlLabel>
				<InputGroup bsSize="large">
					<If condition={icon}>
						<InputGroup.Addon>
							<i className={`fa fa-${icon}`} />
						</InputGroup.Addon>
					</If>
					<FormControl
						type={type}
						name={name}
						autoComplete={type === 'password' ? 'off' : null}
						defaultValue={value}
						placeholder={placeholder}
						className="font-size-14 color-gray-bayoux font-regular bg-white"
					/>
				</InputGroup>
			</FormGroup>
		);
	}
}

FieldGroup.propTypes = {
	icon            : PropTypes.string,
	id              : PropTypes.string,
	label           : PropTypes.string,
	placeholder     : PropTypes.string,
	name            : PropTypes.string,
	type            : PropTypes.string.isRequired,
	validationState : PropTypes.string,
	value           : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
};

FieldGroup.defaultProps = {
	icon            : '',
	id              : '',
	label           : '',
	name            : '',
	validationState : '',
	value           : '',
	placeholder    	: '',
};

export default FieldGroup;
